import EditRoundedIcon from '@mui/icons-material/EditRounded';

export default EditRoundedIcon;
